import { render, staticRenderFns } from "./StaffPicker.vue?vue&type=template&id=477f9411&scoped=true&"
import script from "./StaffPicker.vue?vue&type=script&lang=js&"
export * from "./StaffPicker.vue?vue&type=script&lang=js&"
import style0 from "./StaffPicker.vue?vue&type=style&index=0&id=477f9411&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f9411",
  null
  
)

export default component.exports